"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfViewer = void 0;
const react_1 = __importStar(require("react"));
const entry_webpack_1 = require("react-pdf/dist/esm/entry.webpack");
const react_i18next_1 = require("react-i18next");
const react_components_1 = require("@cimpress/react-components");
exports.PdfViewer = (props) => {
    const { t } = react_i18next_1.useTranslation();
    const [numPages, setNumPages] = react_1.useState();
    return (props.pdf
        ? react_1.default.createElement(react_components_1.Card, { className: 'documentCard' },
            react_1.default.createElement("div", { className: 'documentSection' },
                react_1.default.createElement("div", { className: 'documentPreview' },
                    react_1.default.createElement(entry_webpack_1.Document, { file: props.pdf, onLoadSuccess: loadedPDF => {
                            setNumPages(loadedPDF.numPages);
                        }, onLoadError: console.error, loading: 'Loading...' }, [...Array(numPages).keys()].map((k, i) => react_1.default.createElement(entry_webpack_1.Page, { key: i, pageNumber: k + 1 }))))))
        : react_1.default.createElement("span", null, t('error.error')));
};
//# sourceMappingURL=pdfViewer.js.map